/**
 * Why a user says an answer was wrong.
 *
 * Numbers, because that is what the API sends and reads: it serializes with Newtonsoft.Json and
 * registers no string-enum converter. They start at 1 so a request that left the reason out is
 * refused rather than read as a report.
 */
export enum AnswerFeedbackReason {
  Wrong = 1,
  Incomplete = 2,
  CitedTheWrongSource = 3,
  ShouldNotHaveHadAccess = 4
}

/**
 * Which queue a report goes to. An access report says a permission check may have failed, which
 * is a security report rather than a quality signal, and the server routes it separately.
 */
export enum AnswerFeedbackCategory {
  Quality = 1,
  Access = 2
}

/** The reasons in the order the control offers them. */
export const answerFeedbackReasons: readonly AnswerFeedbackReason[] = [
  AnswerFeedbackReason.Wrong,
  AnswerFeedbackReason.Incomplete,
  AnswerFeedbackReason.CitedTheWrongSource,
  AnswerFeedbackReason.ShouldNotHaveHadAccess,
];

/** How the control names each reason to the person choosing it. */
export const describeAnswerFeedbackReason = (reason: AnswerFeedbackReason): string => {
  switch (reason) {
    case AnswerFeedbackReason.Wrong:
      return "It's wrong";
    case AnswerFeedbackReason.Incomplete:
      return "It's incomplete";
    case AnswerFeedbackReason.CitedTheWrongSource:
      return "It cited the wrong source";
    case AnswerFeedbackReason.ShouldNotHaveHadAccess:
      return "It showed me something I shouldn't see";
  }
};

export const categoryOfAnswerFeedbackReason = (reason: AnswerFeedbackReason): AnswerFeedbackCategory =>
  reason === AnswerFeedbackReason.ShouldNotHaveHadAccess
    ? AnswerFeedbackCategory.Access
    : AnswerFeedbackCategory.Quality;
